import { createMuiTheme } from '@material-ui/core'
import overrides from './overrides-consumer'
import colors from './colors'
import shadows from './shadows'
import typography from './mytypography'

const muiTheme = {
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1248,
      xl: 1920
    }
  },
  shadows,
  colors,
  typography,
  spacing: 8,
  palette: {
    primary: { main: colors.blue1 },
    secondary: { main: colors.pink, contrastText: colors.white },
    neutral: { main: colors.white, contrastText: colors.blue5 },
    action: {
      disabledBackground: colors.pinkTransparent,
      disabled: colors.white
    }
  },
  overrides: overrides()
}

const theme = {
  //...TruphoneTheme,
  ...muiTheme
}

export default createMuiTheme(theme)
